<template>
  <div class="edit">
    <CloseModalBtn :closeModal="closeModal" />
    <h5>
      {{
        create
          ? localStorage.translations.pages['setting-scheme_type']['dialogs-add_edit'][
              'dobavlenie-tipa-chertezha'
            ]
          : localStorage.translations.pages['setting-scheme_type']['dialogs-add_edit'][
              'redaktirovanie-tipa-chertezha'
            ]
      }}
    </h5>
    <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="createOrUpdate">
      <label>{{
        localStorage.translations.pages['setting-scheme_type']['dialogs-add_edit-labels'][
          'nazvanie'
        ]
      }}</label>
      <transition name="fade" mode="out-in">
        <v-skeleton-loader
          v-if="!create && !workDocsSchemeTypeShow"
          width="100%"
          height="86px"
          type="list-item"
        />
        <v-text-field
          v-else
          outlined
          height="48px"
          :placeholder="
            localStorage.translations.pages['setting-scheme_type']['dialogs-add_edit-labels'][
              'nazvanie'
            ]
          "
          v-model="name"
          prepend-inner-icon="mdi-file-cad-box"
          :rules="[inputRules.required, inputRules.max100]"
        />
      </transition>

      <div class="container_btn">
        <BaseButton
          type="submit"
          :text="
            localStorage.translations.pages['setting-scheme_type']['dialogs-add_edit-buttons'][
              'sohranit'
            ]
          "
          default_icon="button-save"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'WorkDocsSchemeTypeModalForm',
  components: { CloseModalBtn },
  props: ['id', 'dialog', 'closeModal', 'create'],

  data() {
    return {
      valid: true,
      name: '',
    }
  },
  created() {
    if (!this.create) {
      this.onWorkDocsSchemeTypeShow(this.id)
    }
  },

  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workDocsSchemeType', ['workDocsSchemeTypeShow']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    SettingWorkDocsSchemeTypePage() {
      return this.$route.name === 'SettingWorkDocsSchemeType'
    },
  },
  watch: {
    workDocsSchemeTypeShow() {
      this.name = this.workDocsSchemeTypeShow.name
    },
  },
  methods: {
    ...mapActions('workDocsSchemeType', [
      'onWorkDocsSchemeTypeShow',
      'onWorkDocsSchemeTypeCreate',
      'onWorkDocsSchemeTypeGrid',
      'onWorkDocsSchemeTypeUpdate',
      'onWorkDocsSchemeTypeAll',
    ]),
    validate() {
      this.$refs.form.validate()
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    async createOrUpdate() {
      await this.validate()
      if (this.valid === true) {
        if (this.create) {
          let data = {
            name: this.name,
          }
          this.onWorkDocsSchemeTypeCreate(data)
            .then((response) => {
              if (response) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'uspeshno-dobavlen'
                      ],
                    IsError: false,
                  },

                  { root: true },
                )
                if (this.SettingWorkDocsSchemeTypePage) {
                  this.onWorkDocsSchemeTypeGrid({
                    limit: this.$route.query.limit,
                    page: this.$route.query.page,
                  })
                } else {
                  this.onWorkDocsSchemeTypeAll()
                }

                this.closeModal()
              }
            })
            .catch((err) => {
              if (err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        } else {
          let data = {
            id: this.workDocsSchemeTypeShow.id,
            name: this.name,
          }
          this.onWorkDocsSchemeTypeUpdate(data)
            .then((response) => {
              if (response) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'izmeneniya-uspeshno-sohraneny'
                      ],
                    IsError: false,
                  },

                  { root: true },
                )
                this.onWorkDocsSchemeTypeGrid({
                  limit: this.$route.query.limit,
                  page: this.$route.query.page,
                })
                this.closeModal()
              }
            })
            .catch((err) => {
              if (err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit:deep() {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    label {
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      color: #52525f;
    }

    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      display: grid;
      justify-content: center;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>
